import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillGoogleSquare,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <div className="content-panel">
            <p className="project-kicker">About Me</p>
            <h1 style={{ fontSize: "2.6em" }}>
              Product-minded engineer with a systems core.
            </h1>
            <p className="home-about-body">
              I worked as a Software Development Engineer <a href="https://www.commbank.com.au/" className="purple" style={{ textDecoration: "none" }}>@Commonwealth Bank of Australia</a> and <a href="https://www.datacore.com" className="purple" style={{ textDecoration: "none" }}>@DataCore Software.</a> and <a href="https://www.worldquant.com" className="purple" style={{ textDecoration: "none" }}>@WorldQuant</a>.
              <br />
              Graduated with a Master's degree in Computer Science specializing in Artificial Intelligence from the <a href="https://www.warwick.ac.uk/" className="purple" style={{ textDecoration: "none" }}>University of Warwick (UK).</a>
              <br />
              <br />
              🚀 Software Alchemist with a knack for turning code into pure magic. Passionate about creating innovative solutions that push boundaries and delight users.
              Experienced in developing cutting-edge applications with a touch of enchantment.
              Seeking exciting opportunities to challenge the status quo and make a real impact.
              <br />
              Open to new opportunities in the software development field. Let's connect and explore potential collaborations!"
            </p>
            </div>
          </Col>
          {/* <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col> */}
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <div className="content-panel content-panel-compact">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/sauravjaiswalsj"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://twitter.com/sauravjaiswal99"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/sauravjaiswalsj"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://notesj.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillGoogleSquare />
                </a>
              </li>
            </ul>
            <div className="home-link-pills">
              <a
                href="https://notesj.vercel.app/"
                target="_blank"
                rel="noreferrer"
                className="home-link-pill"
              >
                Notes App + Blog
              </a>
              <a
                href="https://github.com/sauravjaiswalsj"
                target="_blank"
                rel="noreferrer"
                className="home-link-pill"
              >
                GitHub Projects
              </a>
            </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Container >
  );
}
export default Home2;
